import { IOrigins } from '../models';
import { getCountries } from '../constants/countries.constant';
import { getNationalities } from '../constants/nationalities.constant';
import { getLanguages } from '../constants/languages.constant';

export const getCountry = (value: any): IOrigins | undefined => {
    if (!value) return;
    return getCountries.find(({ code }) => code === value.toLowerCase());
};

export const getLanguage = (value: any): IOrigins | undefined => {
    if (!value) return;
    return getLanguages.find(({ code }) => code === value.toLowerCase());
};

export const getNationality = (value: any): IOrigins | undefined => {
    if (!value) return;
    return getNationalities.find(({ code }) => code === value.toLowerCase());
};

export const validateOriginOption = (option: IOrigins, value: any): boolean => {
    if (!value) return false;
    return (
        option.code.toLowerCase() === value.code.toLowerCase() ||
        option.label.toLowerCase() == value.label.toLowerCase()
    );
};
